export const messages = {
  title: {
    id: 'admin/promotions.form.more-for-less.title',
  },
  validation: {
    empty: {
      id: 'admin/promotions.form.group-box.validation.empty',
    },
    generic: {
      id: 'admin/promotions.form.group-box.validation.generic',
    },
  },
}
